import { ReactComponent as Italy } from 'assets/images/it.svg';
import { ReactComponent as England } from 'assets/images/en.svg';
import { ReactComponent as France } from 'assets/images/fr.svg';
import { ReactComponent as Spain } from 'assets/images/es.svg';
import { ReactComponent as Germany } from 'assets/images/ge.svg';
import { ReactComponent as Russia } from 'assets/images/ru.svg';
import { ReactComponent as Poland } from 'assets/images/pl.svg';

export const MultiLangData = {
  it: {
    key: 'it',
    icon: Italy,
  },
  en: {
    key: 'en',
    icon: England,
  },
  fr: {
    key: 'fr',
    icon: France,
  },
  es: {
    key: 'es',
    icon: Spain,
  },
  de: {
    key: 'de',
    icon: Germany,
  },
  ru: {
    key: 'ru',
    icon: Russia,
  },
  pl: {
    key: 'pl',
    icon: Poland,
  },
};
